import { initEditor } from './editor-cm6.js'
import { ChatManager } from './chat-button.js'
import { obsidianVault } from './obsidian-vault.js'
import { initMcpPromptsPanel } from './mcp-prompts-panel.js'
import { PanelResizer } from './panel-resizer.js'
import { initBuddyAuswahl } from './buddy-auswahl.js'
import { initAppSwitcher } from '../../../../../platform/shared/app-switcher.js'
import { initProfilePanel } from '../../../../../platform/shared/profile-panel.js'
import './script.js'

// Icon der Leisten-Aktion „Tool-Prompts" (Systemprompts der Werkzeuge).
const PROMPT_ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" ' +
  'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
  '<path d="M4 4h16v12H7l-3 3z"/><path d="M8 9h8M8 12.5h5"/></svg>'

// Initialize editor after DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  try {
    // Pass configuration to disable line numbers and fold gutter
    const editorApi = initEditor({
      showLineNumbers: false,
      showFoldGutter: false
    })

    // Make the editor API accessible globally if needed
    window.editorApi = editorApi

    // Initialize chat manager and bind event handlers
    const chatManager = new ChatManager()
    window.chatManager = chatManager
    chatManager.init()

    // Setup chat button handlers
    setupChatButtonHandlers(chatManager)

    // Make obsidian vault accessible globally
    window.obsidianVault = obsidianVault

    // Vault-Icon unter dem App-Switcher öffnet den Vault.
    // Offenes Switcher-Panel vorher schließen — das Overlay läge sonst darunter.
    document.getElementById('headerVaultBtn')?.addEventListener('click', () => {
      window.__mednosSwitcher?.close()
      obsidianVault.open()
    })

    // Profil-Badge unten links (Styling + Initialen-Befüllung übernimmt das
    // gemeinsame Modul); Klick öffnet das Profil-Panel.
    const loadRadiologyUser = () =>
      fetch('/api/auth/verify', { credentials: 'same-origin' })
        .then((res) => (res.ok ? res.json() : null))
        .catch(() => null)
    initProfilePanel({
      badge: '#profileBadge',
      loadUser: loadRadiologyUser,
      onLogout: () => {
        if (window.Auth) window.Auth.logout()
        else window.location.href = 'https://mednos.eu'
      },
    })

    // Gemeinsamer App-Switcher (platform/shared): Panel identisch in allen
    // Apps, Offen-Zustand überlebt den App-Wechsel (Cookie auf .mednos.eu).
    // Die Panel-Aktionen nutzen dieselben SVGs wie die Corner-Icon-Buttons;
    // das Panel bleibt beim Klick offen (Overlays liegen über z 9999).
    initAppSwitcher({
      appKey: 'radiology',
      // Radiology-Corner sitzt bewusst 0.8mm tiefer als Study (header.css)
      topNudge: '0.8mm',
      skin: 'transparent',
      // Ueberlagert, statt die Seite zu schieben: beim Oeffnen springt sonst
      // der Editor nach rechts.
      dock: false,
      actions: [
        {
          icon: document.getElementById('headerVaultBtn')?.innerHTML || '',
          label: 'Vault',
          onClick: () => obsidianVault.open(),
        },
        {
          icon: PROMPT_ICON,
          label: 'Tool-Prompts',
          onClick: () => window.mcpPromptsPanel?.openOverlay(),
        },
      ],
    })

    // Initialize MCP Prompts panel
    const mcpPromptsPanel = initMcpPromptsPanel()
    window.mcpPromptsPanel = mcpPromptsPanel

    // Markierter Text im Befund oder in einer Notiz: „Buddy fragen"
    initBuddyAuswahl()

    // Initialize panel resizer for drag-to-resize functionality
    const panelResizer = new PanelResizer()
    panelResizer.init()
    panelResizer.restoreSavedWidths()
    window.panelResizer = panelResizer

  } catch (error) {
    console.error('Failed to initialize editor:', error)
  }
})

// Helper function to set up chat button handlers
function setupChatButtonHandlers(chatManager) {
  // Chat panel open button
  const openChatBtn = document.getElementById('btn-open-chat')
  if (openChatBtn) {
    // Remove any existing listeners (to avoid duplicates)
    const newBtn = openChatBtn.cloneNode(true)
    openChatBtn.parentNode.replaceChild(newBtn, openChatBtn)
    
    // Add new listener
    newBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      e.preventDefault()
      chatManager.showChatPanel()
    })
  }
  
  // Die anderen Button-Handler bleiben unverändert
}